const CODEY = 'codey';
const MICROBIT = 'microbit';
const NEURON = 'neuron';
const MCORE = 'mcore';
const AURIGA = 'auriga';

export default {
    CODEY,
    MICROBIT,
    NEURON,
    MCORE,
    AURIGA
};